module.exports = __webpack_public_path__ + "static/media/dice-d8.d3b1942b.svg";